exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1500px){.container-fluid[data-v-5a26b71b]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-5a26b71b]{width:60%}}.lnk[data-v-5a26b71b]{cursor:pointer}.centered-and-cropped[data-v-5a26b71b]{object-fit:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a26b71b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/downloads/DownloadList.vue
// module id = 172
// module chunks = 0